import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ApexOptions, NgApexchartsModule } from "ng-apexcharts";
import {
  buildCourtOccupancyChart,
  courtOccupancyChartHeight,
} from "./court-occupancy-chart";
import { CourtOccupancyService } from "./court-occupancy.service";
import { CourtOccupancyRow } from "./court-occupancy.types";

@Component({
  selector: "app-court-occupancy-chart",
  templateUrl: "./court-occupancy-chart.component.html",
  styleUrls: ["./court-occupancy-chart.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    NgApexchartsModule,
  ],
})
export class CourtOccupancyChartComponent implements OnInit {
  readonly reportingDays = 7;
  rows: CourtOccupancyRow[] = [];
  chartOptions: ApexOptions = buildCourtOccupancyChart([]);
  chartHeight = courtOccupancyChartHeight(0);
  isLoading = true;
  errorMessage = "";

  get overallOccupancyPercent(): number | null {
    const totals = this.rows.reduce(
      (result, row) => ({
        booked: result.booked + row.occupiedMinutes,
        bookable: result.bookable + row.bookableMinutes,
      }),
      { booked: 0, bookable: 0 },
    );
    return totals.bookable > 0
      ? Number(((totals.booked / totals.bookable) * 100).toFixed(1))
      : null;
  }

  constructor(
    private readonly _courtOccupancyService: CourtOccupancyService,
    private readonly _cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.isLoading = true;
    this.errorMessage = "";
    this._courtOccupancyService
      .getCourtOccupancy(this.reportingDays)
      .subscribe({
        next: (response) => {
          this.rows = Array.isArray(response?.rows) ? response.rows : [];
          this.chartHeight = courtOccupancyChartHeight(this.rows.length);
          this.chartOptions = buildCourtOccupancyChart(this.rows);
          this.isLoading = false;
          this._cdr.markForCheck();
        },
        error: () => {
          this.rows = [];
          this.isLoading = false;
          this.errorMessage =
            "Court occupancy could not be loaded. Please try again.";
          this._cdr.markForCheck();
        },
      });
  }

  formatHours(minutes: number): string {
    return (minutes / 60).toLocaleString("en-US", {
      maximumFractionDigits: 1,
    });
  }

  trackByCourtId(_index: number, row: CourtOccupancyRow): string {
    return row.courtId;
  }
}
